import {
  Box,
  Button,
  Chiclet as Chl,
  DrawingBoard,
  FileUpload,
  FormInput,
  Icon,
  InlineCopy,
  Label,
  Text,
  TextInput,
  Title
} from 'components'
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useFileQuery, useGetQuery, usePostQuery } from 'hooks'
import { Actions, PostTypeSelector, PostTypeOption } from './components'

const POST_TYPES = {
  UPLOAD: 'upload',
  DRAW: 'draw',
  TEXT: 'text'
}

export const CreatePost = () => {
  const [active, setActive] = useState()
  const [formData, setFormData] = useState(null)
  const [postType, setPostType] = useState(null)
  const { postable_type, postable_id } = useParams()
  const [state, setState] = useState({ title: '', body: '' })
  const navigate = useNavigate()

  const { post, data: postRes } = usePostQuery({
    url: '/posts'
  })

  const { post: uploadMedia, data: mediaData, isFetching } = useFileQuery({
    url: '/posts/upload_media'
  })

  const setMedia = async ({ target: { name, files, value } }) => {
    if (files && files[0]) {
      const formData = await new FormData()
      formData.append('file', files[0], files[0].name)
      const req = await uploadMedia(formData)
    }
  }

  const handler = async ({ target: { name, files, value } }) => {
    setState({ ...state, [name]: value })
  }

  useEffect(() => {
    if (postable_type && postable_id) {
      setState(prevState => ({ ...prevState, postable_type, postable_id }))
    }
  }, [postable_type, postable_id])

  useEffect(() => {
    if (mediaData?.asset?.name) {
      setState(prevState => ({ ...prevState, media: mediaData.asset }))
    }
  }, [mediaData])

  useEffect(() => {
    if (postRes?.data?.id) {
      history.go(-1)
    };
  }, [postRes])

  const createPost = async () => {
    const payload = { ...state, postable_type, postable_id }
    console.log('Creating post with payload:', payload)
    const res = await post(payload)
  }

  const saveDrawing = async () => {
    const req = await uploadMedia(formData)
  }

  const renderPostTypeSelector = () => (
    <PostTypeSelector>
      <PostTypeOption
        selected={postType === POST_TYPES.UPLOAD}
        onClick={() => setPostType(POST_TYPES.UPLOAD)}
      >
        <Icon icon="upload" />
        <Text>Upload Image</Text>
      </PostTypeOption>
      <PostTypeOption
        selected={postType === POST_TYPES.DRAW}
        onClick={() => setPostType(POST_TYPES.DRAW)}
      >
        <Icon icon="brush" />
        <Text>Draw Image</Text>
      </PostTypeOption>
      <PostTypeOption
        selected={postType === POST_TYPES.TEXT}
        onClick={() => setPostType(POST_TYPES.TEXT)}
      >
        <Icon icon="text" />
        <Text>Text & Image</Text>
      </PostTypeOption>
    </PostTypeSelector>
  )

  const renderUploadType = () => (
    <>
      <Box padding="0.5rem">
        <Label>Title</Label>
        <FormInput name="title" value={state.title} onChange={handler} />
      </Box>
      {isFetching ? (
        <Box padding="1rem">
          <Text>Uploading image...</Text>
        </Box>
      ) : state.media ? (
        <Box padding="0.5rem">
          <Text>Image uploaded: {state.media.name}</Text>
        </Box>
      ) : (
        <FileUpload
          name="media"
          buttonLabel="Choose an image"
          label="or drag and drop"
          onChange={setMedia}
        />
      )}
      <Actions>
        <Button className="large" onPress={() => setPostType(null)}>Back</Button>
        <Button className="large" disabled={isFetching || !state.media} onPress={createPost}>Post</Button>
      </Actions>
    </>
  )

  const renderDrawType = () => (
    <>
      <DrawingBoard onChange={setFormData} onDrawReady={() => setActive(true)} />
      <Actions>
        <Button className="large" onPress={() => setPostType(null)}>Back</Button>
        <Button className="large" disabled={isFetching || mediaData?.asset?.name || !active} onPress={saveDrawing}>{isFetching ? 'uploading..' : 'Save'}</Button>
        <Button className="large" disabled={!state.media} onPress={createPost}>Post</Button>
      </Actions>
    </>
  )

  const renderTextType = () => (
    <>
      <Box padding="0.5rem">
        <Label>Title</Label>
        <FormInput name="title" value={state.title} onChange={handler} />
      </Box>
      <Box padding="0.5rem">
        <Label>Body</Label>
        <TextInput name="body" value={state.body} onChange={handler} />
      </Box>
      {isFetching ? (
        <Box padding="1rem">
          <Text>Uploading image...</Text>
        </Box>
      ) : state.media ? (
        <Box padding="0.5rem">
          <Text>Image uploaded: {state.media.name}</Text>
        </Box>
      ) : (
        <FileUpload
          name="media"
          buttonLabel="Add an image (optional)"
          label="or drag and drop"
          onChange={setMedia}
        />
      )}
      <Actions>
        <Button className="large" onPress={() => setPostType(null)}>Back</Button>
        <Button className="large" disabled={isFetching || (!state.body && !state.title)} onPress={createPost}>Post</Button>
      </Actions>
    </>
  )

  const renderContent = () => {
    switch (postType) {
      case POST_TYPES.UPLOAD:
        return renderUploadType()
      case POST_TYPES.DRAW:
        return renderDrawType()
      case POST_TYPES.TEXT:
        return renderTextType()
      default:
        return renderPostTypeSelector()
    }
  }

  return <>{renderContent()}</>
}
